import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { SupportEntry } from "./support/SupportEntry";
import "./styles.css";

if(import.meta.env.PROD&&"serviceWorker" in navigator){window.addEventListener("load",()=>{void navigator.serviceWorker.register("/sw.js",{scope:"/"}).catch(()=>undefined);});}

const root = document.getElementById("root");
if (root === null) throw new Error("Root element was not found");

createRoot(root).render(
  <StrictMode>
    <AuthProvider><App /><SupportEntry /></AuthProvider>
  </StrictMode>
);
